import {
  FETCH_UNREAD_NOTIFICATIONS,
  GET_REFRESH_NOTIFICATIONS,
  GET_UNREAD_NOTIFICATIONS,
  SET_REFRESH_NOTIFICATIONS,
  SET_UNREAD_NOTIFICATIONS,
} from '@/store/actions'
import API from '@/api'

export default {
  state: {
    unreadQuantity: 0,
    refreshInterval: 60000,
  },
  getters: {
    [GET_UNREAD_NOTIFICATIONS]: state => state.unreadQuantity,
    [GET_REFRESH_NOTIFICATIONS]: state => state.refreshInterval * 1000,
  },
  actions: {
    [FETCH_UNREAD_NOTIFICATIONS]: async ({ commit }) => {
      try {
        const { data } = await API.notifications.getUnreadQuantity()

        commit(SET_UNREAD_NOTIFICATIONS, data.count)
        commit(SET_REFRESH_NOTIFICATIONS, data.interval || 60000)
      } catch (error) {
        console.log('error', error)
      }
    },
  },
  mutations: {
    [SET_UNREAD_NOTIFICATIONS]: (state, payload) => {
      state.unreadQuantity = payload
    },
    [SET_REFRESH_NOTIFICATIONS]: (state, payload) => {
      state.refreshInterval = payload
    },
  },
}
